(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sc-banner')) {
 customElements.define('sc-banner', class extends HTMLElement {
  connectedCallback() {
   this.controller = new AbortController();
   const signal = this.controller.signal;
   this.slides = [...this.querySelectorAll('[data-sc-slide]')];
   this.dots = [...this.querySelectorAll('[data-sc-go]')];
   this.index = 0;
   this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
   this.hovered = false;
   this.focused = false;
   this.pauseButton = this.querySelector('[data-sc-pause]');
   this.querySelector('[data-sc-prev]')?.addEventListener('click', () => this.go(this.index - 1), {signal});
   this.querySelector('[data-sc-next]')?.addEventListener('click', () => this.go(this.index + 1), {signal});
   this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i), {signal}));
   this.pauseButton?.addEventListener('click', () => {this.paused = !this.paused; this.updatePause(); this.schedule();}, {signal});
   this.addEventListener('mouseenter', () => {this.hovered = true; this.schedule();}, {signal});
   this.addEventListener('mouseleave', () => {this.hovered = false; this.schedule();}, {signal});
   this.addEventListener('focusin', () => {this.focused = true; this.schedule();}, {signal});
   this.addEventListener('focusout', event => {this.focused = this.contains(event.relatedTarget); this.schedule();}, {signal});
   this.addEventListener('keydown', event => {
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault(); this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));}
   }, {signal});
   this.addEventListener('touchstart', event => {this.startX = event.changedTouches[0].clientX; this.startY = event.changedTouches[0].clientY; clearInterval(this.timer);}, {signal, passive:true});
   this.addEventListener('touchend', event => {
    const dx = event.changedTouches[0].clientX - this.startX;
    const dy = event.changedTouches[0].clientY - this.startY;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) this.go(this.index + (dx < 0 ? 1 : -1));
    this.schedule();
   }, {signal, passive:true});
   document.addEventListener('visibilitychange', () => this.schedule(), {signal});
   document.addEventListener('shopify:block:select', event => {
    const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
    if (index >= 0) {this.paused = true; this.go(index); this.updatePause();}
   }, {signal});
   this.updatePause(); this.schedule();
  }
  disconnectedCallback() {clearInterval(this.timer); this.controller?.abort();}
  updatePause() {
   if (!this.pauseButton) return;
   this.pauseButton.textContent = this.paused ? '▷' : 'Ⅱ';
   this.pauseButton.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
   this.pauseButton.setAttribute('aria-pressed', String(this.paused));
  }
  go(index) {
   if (!this.slides.length) return;
   this.index = (index + this.slides.length) % this.slides.length;
   this.slides.forEach((slide,i) => {slide.hidden = i !== this.index; slide.inert = i !== this.index; slide.setAttribute('aria-hidden', String(i !== this.index));});
   this.dots.forEach((dot,i) => dot.setAttribute('aria-current', String(i === this.index)));
   this.schedule();
  }
  schedule() {
   clearInterval(this.timer);
   if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || this.paused || this.hovered || this.focused || document.hidden) return;
   this.timer = setInterval(() => this.go(this.index + 1), Number(this.dataset.interval) || 7000);
  }
 });
}

  } catch(e) { console.error(e); }
})();
})();
